<template>
  <div
    v-show="tags.length"
    class="i-tag-list"
  >
    <span
      v-for="tag in tags"
      :key="tag"
      class="tag"
      @click.stop="onClick(tag)"
    >{{ tag }}</span>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    tags: {
      type: Array,
      default () {
        return []
      }
    }
  },
  methods: {
    ...mapActions([
      'setSearchKeywords',
      'initSearch',
      'showSearchs',
      'closeInformation',
      'closeShare',
      'closeMarkerInfo',
      'closeLocation',
      'closeComments',
      'closePopup'
    ]),
    onClick (tag) {
      this.initSearch()
      this.setSearchKeywords(tag)
      this.showSearchs()
      this.closeInformation()
      this.closeShare()
      this.closeMarkerInfo()
      this.closeLocation()
      this.closeComments()
      this.closePopup()
      this.$emit('click', tag)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .i-tag-list {
    .tag {
      display: inline-block
      padding: 5px 12px
      margin-right: 12px
      margin-bottom: 5px
      color: #919191
      background-color: #E5E5E5
      text-shadow: none
      border-radius: 2px
      cursor: pointer
    }
  }
</style>
